import mainVue from '@/main'
export default {
    //discount显示函数
    displayDiscountPercent(p) {
        let rem = Math.floor(p / 100)
        if (rem >= 10) {
            return (rem % 10 == 0) ? (rem / 10) : rem
        } else {
            return '0.' + rem
        }
    },

    //减 
    floatSub(arg1, arg2) {
        var r1, r2, m, n;
        try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
        try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
        m = Math.pow(10, Math.max(r1, r2));
        //动态控制精度长度 
        n = (r1 >= r2) ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },

    //加 
    floatAdd(arg1, arg2) {
        var r1, r2, m;
        try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
        try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
        m = Math.pow(10, Math.max(r1, r2));
        return (arg1 * m + arg2 * m) / m;
    },

    //乘 
    floatMul(arg1, arg2) {
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try { m += s1.split(".")[1].length } catch (e) { }
        try { m += s2.split(".")[1].length } catch (e) { }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    },

    //除 
    floatDiv(arg1, arg2) {
        var t1 = 0, t2 = 0, r1, r2;
        try { t1 = arg1.toString().split(".")[1].length } catch (e) { }
        try { t2 = arg2.toString().split(".")[1].length } catch (e) { }
        r1 = Number(arg1.toString().replace(".", ""));
        r2 = Number(arg2.toString().replace(".", ""));
        return (r1 / r2) * Math.pow(10, t2 - t1);
    },

    // 保留小数点后两位
    cutOutNum(t) {
        return t.toString().match(/^\d*(\.?\d{0,2})/g)[0] || null
    },

    // 获取斜杠后面的内容
    substringFn(t) {
        var htmlHref = t
        htmlHref = htmlHref.replace(/^http:\/\/[^/]+/, '')
        var addr = htmlHref.substr(
            htmlHref.lastIndexOf('/', htmlHref.lastIndexOf('/') - 1) + 1
        )
        var index = addr.lastIndexOf('/')
        //js 获取字符串中最后一个斜杠后面的内容
        var addrLast = decodeURI(addr.substring(index + 1, addr.length))
        return addrLast
    },

    // 时间格式化
    dateTimeFormateFn(date, type) {
        if (!date) {
            return
        } else {
            var d = new Date(date);
            d = d.getFullYear() > 0 ? d : new Date(Date.parse(date.replace(/-/g, "/")));        //为了兼容ios
            var year = d.getFullYear();
            var month = ('0' + (d.getMonth() + 1)).slice(-2);
            var day = ('0' + (d.getDate())).slice(-2);
            var hour = ('0' + (d.getHours())).slice(-2);
            var minutes = ('0' + (d.getMinutes())).slice(-2);
            var seconds = ('0' + (d.getSeconds())).slice(-2);
            if (type == 'all') {
                return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
            }
            else if (type == 'dayMinutes') {
                return `${month}.${day} ${hour}:${minutes}`;
            }
            else if (type == 'time') {
                return hour + ":" + minutes + ":" + seconds;
            }
            else if (type == 'month') {
                return `${year}-${month}`;
            }
            else {
                return `${year}-${month}-${day}`;
            }
        }
    },

    // 取随机数
    randomNum(maxNum, minNum, decimalNum) {
        // 获取指定范围内的随机数, decimalNum指小数保留多少位
        var max = 0,
            min = 0;
        minNum <= maxNum ? (min = minNum, max = maxNum) : (min = maxNum, max = minNum);
        switch (arguments.length) {
            case 1:
                return Math.floor(Math.random() * (max + 1));
                break;
            case 2:
                return Math.floor(Math.random() * (max - min + 1) + min);
                break;
            case 3:
                return (Math.random() * (max - min) + min).toFixed(decimalNum);
                break;
            default:
                return Math.random();
                break;
        }
    },

    //获取页面中某元素的绝对坐标位置
    // 获取顶部div的距离
    getParentTop(e) {
        var offset = e.offsetTop
        if (e.offsetParent != null) {
            offset += this.getParentTop(e.offsetParent)
        }
        return offset
    },

    // 获取左侧div的距离
    getParentLeft(e) {
        var offset = e.offsetLeft
        if (e.offsetParent != null) {
            offset += this.getParentLeft(e.offsetParent)
        }
        return offset
    },

    //打乱数组顺序
    shuffle(array) {
        let counter = array.length;

        // While there are elements in the array
        while (counter > 0) {
            // Pick a random index
            let index = Math.floor(Math.random() * counter);

            // Decrease counter by 1
            counter--;

            // And swap the last element with it
            let temp = array[counter];
            array[counter] = array[index];
            array[index] = temp;
        }

        return array;
    },

    // 将数字取整为10的倍数
    //   @param {Number} num 需要取整的值
    //  * @param {Boolean} ceil 是否向上取整
    //  * @param {Number} prec 需要用0占位的数量
    formatInt(num, prec = 2, ceil = false) {
        const len = String(num).length;
        if (len <= prec) { return num };

        const mult = Math.pow(10, prec);
        return ceil ?
            Math.ceil(num / mult) * mult :
            Math.floor(num / mult) * mult;
    },

    //获取时分秒
    parseTime(ms) {
        return {
            days: Math.floor(ms / 86400000),
            hours: Math.floor((ms % 86400000) / 3600000),
            minutes: Math.floor((ms % 3600000) / 60000),
            seconds: Math.floor((ms % 60000) / 1000),
            milliseconds: ms % 1000,
        }
    },

    //天时分秒拼接
    showDate(ms) {
        let obj = {
            days: Math.floor(ms / 86400000),
            hours: Math.floor((ms % 86400000) / 3600000),
            minutes: Math.floor((ms % 3600000) / 60000),
            seconds: Math.floor((ms % 60000) / 1000),
            milliseconds: ms % 1000,
        }
        let day
        let hours
        let minutes
        let seconds
        if (obj.days > 0) {
            day = `${obj.days}天`
        } else {
            day = ''
        }
        if (obj.hours > 0) {
            hours = `${obj.hours}时`
        } else {
            hours = ''
        }
        if (obj.minutes > 0) {
            minutes = `${obj.minutes}分`
        } else {
            minutes = ''
        }
        if (obj.seconds > 0) {
            seconds = `${obj.seconds}秒`
        } else {
            seconds = ''
        }
        let text = `${day}${hours}${minutes}${seconds}`
        return text
    },

    // 判断Json是否为空
    isEmptyObject(data) {
        let arr = Object.keys(data);
        if (arr.length == 0) {
            return true
        } else {
            return false
        }
    },

    //判断是不是微信打开
    isWeiXin() {
        const ua = window.navigator.userAgent
        return ua.match(/MicroMessenger/i) == 'MicroMessenger'
    },

    //对象里面的值都清空
    objValueIsEmpty(form) {
        for (let key in form) {
            form[key] = ''
        }
        return form
    },

    //将阿拉伯数字翻译成中文的大写数字
    numberToChinese(num) {
        var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九", "十");
        var BB = new Array("", "十", "百", "仟", "萬", "億", "点", "");
        var a = ("" + num).replace(/(^0*)/g, "").split("."),
            k = 0,
            re = "";
        for (var i = a[0].length - 1; i >= 0; i--) {
            switch (k) {
                case 0:
                    re = BB[7] + re;
                    break;
                case 4:
                    if (!new RegExp("0{4}//d{" + (a[0].length - i - 1) + "}$")
                        .test(a[0]))
                        re = BB[4] + re;
                    break;
                case 8:
                    re = BB[5] + re;
                    BB[7] = BB[5];
                    k = 0;
                    break;
            }
            if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0)
                re = AA[0] + re;
            if (a[0].charAt(i) != 0)
                re = AA[a[0].charAt(i)] + BB[k % 4] + re;
            k++;
        }

        if (a.length > 1) // 加上小数部分(如果有小数部分)
        {
            re += BB[6];
            for (var i = 0; i < a[1].length; i++)
                re += AA[a[1].charAt(i)];
        }
        if (re == '一十')
            re = "十";
        if (re.match(/^一/) && re.length == 3)
            re = re.replace("一", "");
        return re;
    },

    //多维数组得深拷贝
    deepcopy(obj) {
        return JSON.parse(JSON.stringify(obj))
    },

    //对象转成数组
    objTurnArr(obj) {
        var arr = []
        for (let i in obj) {
            let o = {};
            o[i] = obj[i]; //即添加了key值也赋了value值 o[i] 相当于o.name 此时i为变量
            arr.push(o)
        }
        return arr
    },

    //对象深拷贝函数 (异步，需要配合async和await)
    structuralClone(obj) {
        return new Promise(resolve => {
            const { port1, port2 } = new MessageChannel()
            port2.onmessage = ev => resolve(ev.data)
            port1.postMessage(obj)
        })
    },

    //第一个对象取值 给第二个对象赋值
    formatFunction(param1, param2) {
        Object.keys(param2).forEach(function(v) {
            param2[v] = param1[v];
        });
        return param2;
    },

    //判断是不是数字
    isNumber(val) {
        // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，
        if (val === "" || val == null) {
            return false;
        }
        if (!isNaN(val)) {
            //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
            //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
            return true;
        }
        else {
            return false;
        }
    },

    // 时间转换 element ui的时间格式
    parserDate(date) {
        if (date) {
            let value = date.substr(0, 4) + '/' + date.substr(5, 2) + '/' + date.substr(8, 2)
            return new Date(value)
        }
    },

    //str:原始字符串，index,开始位置,changeStr，改变后的字
    changeStr(str, index, changeStr) {
        return str.substr(0, index) + changeStr + str.substr(index + changeStr.length);
    },

    //身份证号或者手机号等等字符串想实现替换中间几位字符串
    replacepos(text, start, stop, replacetext) {
        let mystr = text.substr(0, start - 1) + replacetext + text.substr(stop + 1);
        return mystr;
    },

    //将个位数补成十位数
    p(s) {
        return s < 10 ? '0' + s : s
    },

    //获取上个月      获取当前 yy - mm - dd
    getPreMonth(date) {
        var arr = date.split('-');
        var year = arr[0]; //获取当前日期的年份  
        var month = arr[1]; //获取当前日期的月份  
        var day = arr[2]; //获取当前日期的日  
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中月的天数  
        var year2 = year;
        var month2 = parseInt(month) - 1;
        if (month2 == 0) {
            year2 = parseInt(year2) - 1;
            month2 = 12;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
            day2 = days2;
        }
        if (month2 < 10) {
            month2 = '0' + month2;
        }
        var t2 = year2 + '-' + month2 + '-' + day2;
        return t2;
    },

    //获取下个月日期    获取当前 yy - mm - dd
    getNextMonth(date) {
        var arr = date.split('-');
        var year = arr[0]; //获取当前日期的年份  
        var month = arr[1]; //获取当前日期的月份  
        var day = arr[2]; //获取当前日期的日  
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中的月的天数  
        var year2 = year;
        var month2 = parseInt(month) + 1;
        if (month2 == 13) {
            year2 = parseInt(year2) + 1;
            month2 = 1;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
            day2 = days2;
        }
        if (month2 < 10) {
            month2 = '0' + month2;
        }

        var t2 = year2 + '-' + month2 + '-' + day2;
        return t2;
    },

    //这是比较函数 升序  p是某一属性值,如果有sort，那就是降序     使用：arr.sort(compare('age'))
    compare(p, sort) {
        return function(m, n) {
            var a = m[p];
            var b = n[p];
            if (sort) {
                return b - a; //降序
            } else {
                return a - b; //升序
            }
        }
    },

    //判断一个值，距离数组里面的哪个值更接近  数组无序的情况，从头查找
    limit(arr, num) {
        var ret = arr[0];
        var distance = Math.abs(ret - num);
        for (var i = 1; i < arr.length; i++) {
            var newDistance = Math.abs(arr[i] - num);
            if (newDistance < distance) {
                distance = newDistance;
                ret = arr[i];
            }
        }
        return ret;
    },

    //判断一个值，距离数组里面的哪个值更接近  数组有序的情况，二分查找
    closest(arr, num) {
        var left = 0;
        var right = arr.length - 1;

        while (left <= right) {
            var middle = Math.floor((right + left) / 2);
            if (right - left <= 1) {
                break;
            }
            var val = arr[middle];
            if (val === num) {
                return middle;
            }
            else if (val > num) {
                right = middle;
            }
            else {
                left = middle;
            }
        }
        var leftValue = arr[left];
        var rightValue = arr[right];
        return rightValue - num > num - leftValue ? leftValue : rightValue;
    },

    //保留两位小数（不四舍五入）  num是数字  decimal是保留几位小数
    formatDecimal(num, decimal) {
        num = num.toString()
        let index = num.indexOf('.')
        if (index !== -1) {
            num = num.substring(0, decimal + index + 1)
        } else {
            num = num.substring(0)
        }
        return parseFloat(num).toFixed(decimal)
    },

    // js数组根据对象中的元素去重
    arrayUnique2(arr, name) {
        var hash = {};
        return arr.reduce(function(item, next) {
            hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
            return item;
        }, []);
    },

    //判断两个对象是否相等
    isObjectValueEqual(a, b) {
        //取对象a和b的属性名
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);
        //判断属性名的length是否一致
        if (aProps.length != bProps.length) {
            return false;
        }
        //循环取出属性名，再判断属性值是否一致
        for (var i = 0; i < aProps.length; i++) {
            var propName = aProps[i];
            if (a[propName] !== b[propName]) {
                return false;
            }
        }
        return true;
    },

    //分钟数 转换成 小时数
    ChangeHourMinutestr(str) {
        if (!str) return '00:00'
        if (str !== "0" && str !== "" && str !== null) {
            return ((Math.floor(str / 60)).toString().length < 2 ? "0" + (Math.floor(str / 60)).toString() :
                (Math.floor(str / 60)).toString()) + ":" + ((str % 60).toString().length < 2 ? "0" + (str % 60).toString() : (str % 60).toString());
        }
    },

    //小时分钟格式转换为分钟数
    ChangeStrToMinutes(str) {
        var arrminutes = str.split(":");
        if (arrminutes.length == 2) {
            var minutes = parseInt(arrminutes[0]) * 60 + parseInt(arrminutes[1]);
            return minutes;
        }
        else {
            return 0;
        }
    },

    //两数组比较，取不同的值组成新的数组
    takeNewArray(list1, list2) {
        let newArr = []
        list1.forEach((item, index) => {
            var isExist = false;
            list2.forEach(m => {
                if (item == m) {
                    isExist = true;
                    return false;
                }
            })
            if (!isExist) {
                newArr.push(item)
            }
        })
        return newArr
    },

    // 数组去重
    unique(arr) {
        for (var i = 0; i < arr.length; i++) {
            for (var j = i + 1; j < arr.length; j++) {
                if (arr[i] == arr[j]) {         //第一个等同于第二个，splice方法删除第二个
                    arr.splice(j, 1);
                    j--;
                }
            }
        }
        return arr;
    },

    //去除一个数组中与另一个数组中的值相同的元素
    array_diff(a, b) {
        let list = a.filter(items => {
            if (!b.includes(items)) return items;
        })
        return list;
    },

    //生成唯一key
    generateUUID() {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    },

    // 纯数字的唯一id
    getNumberId() {
        var str = '';
        for (var i = 0; i < 7; i += 1) {
            str += Math.floor(Math.random() * 10);
        }
        return str;
    },

    //两个日期之间相差的天数
    getDaysBetween(dateString1, dateString2) {
        var startDate = Date.parse(dateString1);
        var endDate = Date.parse(dateString2);
        var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        // alert(days);
        return days;
    },

    //判断是数组还是obj
    isObjArr(value) {
        if (Object.prototype.toString.call(value) === "[object Array]") {
            console.log('value是数组');
        } else if (Object.prototype.toString.call(value) === '[object Object]') {
            console.log('value是对象');
        } else {
            console.log('value不是数组也不是对象')
        }
    },

    //函数判断是不是obj对象
    isObject(obj) {
        return obj instanceof Object;
    },

    //获取两日期之间日期列表函数   2018-07-25
    getdiffdate(stime, etime) {
        //初始化日期列表，数组
        var diffdate = new Array();
        var i = 0;
        //开始日期小于等于结束日期,并循环
        while (stime <= etime) {
            diffdate[i] = stime;

            //获取开始日期时间戳
            var stime_ts = new Date(stime).getTime();

            //增加一天时间戳后的日期
            var next_date = stime_ts + (24 * 60 * 60 * 1000);

            //拼接年月日，这里的月份会返回（0-11），所以要+1
            var next_dates_y = new Date(next_date).getFullYear() + '-';
            var next_dates_m = (new Date(next_date).getMonth() + 1 < 10) ? '0' + (new Date(next_date).getMonth() + 1) + '-' : (new Date(next_date).getMonth() + 1) + '-';
            var next_dates_d = (new Date(next_date).getDate() < 10) ? '0' + new Date(next_date).getDate() : new Date(next_date).getDate();

            stime = next_dates_y + next_dates_m + next_dates_d;

            //增加数组key
            i++;
        }
        return diffdate
    },


    //将分钟转成时分格式
    toHourMinute(minutes) {
        function p(s) {
            return s < 10 ? '0' + s : s
        }
        return (p(Math.floor(minutes / 60)) + ":" + p(minutes % 60));
        // 也可以转换为json，以方便专外部使用属
        // return {hour:Math.floor(minutes/60),minute:(minutes%60)};
    },

    //获取给定月份N月后的日期   date:当前日期   num：N月后
    getNmonthDate(date, num) {
        var d = new Date(date);
        // 因为getMonth()获取的月份的值只能在0~11之间所以我们在进行setMonth()之前先给其减一
        d.setMonth((d.getMonth() - 1) + (num + 1));
        var yy1 = d.getFullYear();
        var mm1 = d.getMonth() + 1;
        var dd1 = d.getDate();
        if (mm1 < 10) {
            mm1 = '0' + mm1;
        }
        if (dd1 < 10) {
            dd1 = '0' + dd1;
        }
        return `${yy1}-${mm1}-${dd1}`
    },

    //判断两个对象是否相等
    // 列出所有的键，接着遍历数组
    ifCompare(object1, object2) {
        var o1keys = Object.keys(object1);
        var o2keys = Object.keys(object2);
        if (o2keys.length !== o1keys.length) return false;
        for (let i = 0; i <= o1keys.length - 1; i++) {
            let key = o1keys[i];
            if (!o2keys.includes(key)) return false;
            if (object2[key] !== object1[key]) return false;
        }
        return true;
    },


    //输入大于0的正整数
    clearNoNum(value) {
        if (typeof value === 'string') {
            return !isNaN(Number(value)) ? value.replace(/\./g, '') : 0
        } else if (typeof value === 'number') {
            return !isNaN(value) ? String(value).replace(/\./g, '') : 0
        } else {
            return 0
        }
    },


    //根据图片的url返回一个base64编码
    getUrlBase64(url) {
        return new Promise(resolve => {
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            let img = new Image()
            img.crossOrigin = 'Anonymous' //允许跨域
            img.src = url
            img.onload = function() {
                canvas.height = 300
                canvas.width = 300
                ctx.drawImage(img, 0, 0, 300, 300)
                let dataURL = canvas.toDataURL('image/png')
                canvas = null
                resolve(dataURL)
            }
        })
    },

    //一个数组分成多个数组  array数组   subGroupLength数组长度为subGroupLength的小数组
    group(array, subGroupLength) {
        let index = 0;
        let newArray = [];
        while (index < array.length) {
            newArray.push(array.slice(index, index += subGroupLength));
        }
        return newArray;
    },

    // Build a URL with query arguments
    buildUrl(base, queries) {
        let ret = base
        if (typeof (queries) == 'undefined') return ret
        let isFirst = true
        for (let key in queries) {
            let value = queries[key]
            if (isFirst) {
                ret += '?'
                isFirst = false
            } else {
                ret += '&'
            }
            if (typeof (value) == 'undefined' || value === null) {
                ret += key
            } else {
                ret += key + '=' + encodeURIComponent(value)
            }
        }
        return ret
    },

    swapArr(arr, index1, index2) {      //数组交换位置
        arr[index1] = arr.splice(index2, 1, arr[index1])[0];
        return arr;
    },

    // 判断一个对象下是否每个属性都有值
    if_obj_is_null(form) {
        let flag = true;
        for (let key in form) {
            if (!form[key]) {
                return false
            }
        }
        return flag
    },

    //返回上一层
    goBack() {
        if (history.length > 0) {
            window.history.go(-1);
        } else {
            window.location.href = "/";
        }
    },

    //判断是不是https
    ishttps() {
        var ishttps = 'https:' == document.location.protocol ? true : false;
        return ishttps
    },

    //判断是否含有小数点
    isDot(num) {
        // console.log("num", num)
        if (!num) return
        var result = (num.toString()).indexOf(".");
        if (result != -1) {
            return true
        } else {
            return false
        }
    },

    //判断是不是字符串
    isString(str) {
        return (typeof str == 'string') && str.constructor == String;
    },


    toLink(t) {
        mainVue.$router.push({
            path: t,  // 路由的名称
        })
    },

    //判断是移动端还是pc端
    isMobile() {
        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
            return true //移动端页面
        } else {
            return false //pc端页面
        }
    },
}
